import { Icon, IconProps } from "../";

export const AccountLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M12 14C16 14 20 15.34 20 18V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V18C4 15.34 8 14 12 14ZM12 15.5C10.1377 15.5 8.36078 15.8162 7.10938 16.373C5.80611 16.9531 5.5 17.5651 5.5 18V18.5H18.5V18C18.5 17.5651 18.1939 16.9531 16.8906 16.373C15.6392 15.8162 13.8623 15.5 12 15.5ZM12 3.625C14.417 3.625 16.375 5.58297 16.375 8C16.375 10.417 14.417 12.375 12 12.375C9.58297 12.375 7.625 10.417 7.625 8C7.625 5.58297 9.58297 3.625 12 3.625ZM12 5.125C10.4114 5.125 9.125 6.4114 9.125 8C9.125 9.5886 10.4114 10.875 12 10.875C13.5886 10.875 14.875 9.5886 14.875 8C14.875 6.4114 13.5886 5.125 12 5.125Z" />
    </Icon>
  );
};
